import { message } from 'antd'
import { getProps } from '../props';
import { updateClientContact } from '../../../HttpRequests/clientContacts';

export default (values) => async () => {

  const data = {
    client_id: getProps().clientId,
    ...values
  }

  const response = await updateClientContact({ id: values.id, data });

  const clientContact = response.data.data;

  message.success('Contact Updated');

  return clientContact;

}